export default {
    overscrollBehavior: 'contain',
};
